import * as React from 'react'
import {CircularProgress} from "@material-ui/core"

class DashboardLoading extends React.PureComponent<{size?: number}, {}> {
    render() {
        const {size = 24} = this.props
        return (
            <div style={{width: '100%', padding: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <CircularProgress {...{size}} />
            </div>
        );
    }
}

export default DashboardLoading



// WEBPACK FOOTER //
// ./src/page/Consumer/Dashboard/DashboardLoading.tsx